import { useContext } from 'react';
import { ModalContext } from '../containers/Modal';

export function useModal() {
  return useContext(ModalContext);
}
